module.exports = __webpack_public_path__ + "img/free-to-use.796c6f5e.svg";